import React from 'react';
import { Tooltip } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

/**
 * CommentPin — numbered annotation pin rendered on the canvas overlay.
 *
 * Props:
 *   comment      { id, x, y, text, resolved, author }
 *   index        1-based display number
 *   artboardW    artboard width in px  (for absolute positioning)
 *   artboardH    artboard height in px
 *   selected     boolean — orange ring when selected
 *   onClick(id)  called when pin is clicked
 */
const CommentPin = ({ comment, index, artboardW, artboardH, selected, onClick }) => {
  const left = comment.x * artboardW;
  const top = comment.y * artboardH;

  const resolved = comment.resolved;

  const bg = resolved ? '#16a34a' : '#e85d26';
  const preview = comment.text.length > 60
    ? comment.text.slice(0, 60) + '…'
    : comment.text;

  return (
    <Tooltip
      title={
        <span>
          <b>#{index}</b> {preview}
          {resolved && ' ✓'}
        </span>
      }
      placement="top"
      arrow
    >
      <div
        onClick={(e) => { e.stopPropagation(); onClick(comment.id); }}
        style={{
          position: 'absolute',
          left: left - 12,
          top: top - 12,
          width: 24,
          height: 24,
          borderRadius: '50%',
          background: bg,
          color: '#fff',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: 11,
          fontWeight: 700,
          cursor: 'pointer',
          pointerEvents: 'auto',
          zIndex: 20,
          boxShadow: selected
            ? `0 0 0 3px #fff, 0 0 0 5px ${bg}`
            : '0 2px 8px rgba(0,0,0,0.25)',
          transition: 'box-shadow 0.15s',
          userSelect: 'none',
          fontFamily: '-apple-system, sans-serif',
        }}
      >
        {resolved
          ? <CheckCircleIcon sx={{ fontSize: 14 }} />
          : index}
      </div>
    </Tooltip>
  );
};

export default CommentPin;
